window.onIdle =
  window.onIdle ||
  function (callback) {
    const events = ["scroll", "mousemove", "touchstart", "keydown"]
    let done = false

    const trigger = () => {
      if (done) return
      done = true
      events.forEach(event => window.removeEventListener(event, trigger))
      callback()
    }

    events.forEach(event => window.addEventListener(event, trigger, {once: true, passive: true}))
    window.addEventListener("load", () => setTimeout(trigger, 2000))
  }

window.BaseThirdPartyModal =
  window.BaseThirdPartyModal ||
  class BaseThirdPartyModal extends HTMLElement {
    connectedCallback() {
      const prefix = this.tagName.toLowerCase().split("-")[0]
      this.widgetsContainer = this.querySelector(`.${prefix}-modal__widgets`)
      this.dialog = this.querySelector("dialog") || this.querySelector('[role="dialog"]')
      this.widgets = new Map()
      this.activeWidget = null

      this.querySelector(`[data-${prefix}-close]`).addEventListener("click", () => this.close())
      this.addEventListener("click", event => {
        if (event.target === this) this.close()
      })
      this.addEventListener("keydown", event => {
        if (event.code.toUpperCase() === "ESCAPE") this.close()
      })
      if (this.dialog && this.dialog.tagName === "DIALOG") {
        this.dialog.addEventListener("cancel", event => {
          event.preventDefault()
          this.close()
        })
        this.dialog.addEventListener("click", event => {
          const rect = this.dialog.getBoundingClientRect()
          const isInDialog =
            rect.top <= event.clientY &&
            event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX &&
            event.clientX <= rect.left + rect.width
          if (!isInDialog) {
            this.close()
          }
        })
      }
    }

    getWidget(url) {
      let widget = this.widgets.get(url)
      if (!widget) {
        widget = document.createElement("div")
        const prefix = this.tagName.toLowerCase().split("-")[0]
        widget.className = `${prefix}-modal__widget`
        this.createWidgetContent(widget, url)
        this.widgetsContainer.appendChild(widget)
        this.widgets.set(url, widget)
      }
      return widget
    }

    createWidgetContent(widget, url) {}

    open(url, opener) {
      this.opener = opener
      return this.load(url).then(() => {
        if (this.activeWidget) delete this.activeWidget.dataset.active
        this.activeWidget = this.getWidget(url)
        this.activeWidget.dataset.active = "true"

        this.setAttribute("open", "")
        document.body.classList.add("overflow-hidden")
        if (this.dialog && typeof this.dialog.showModal === "function") {
          if (!this.dialog.open) {
            this.dialog.showModal()
          }
        }
        trapFocus(this, this.dialog)
      })
    }

    close() {
      if (!this.hasAttribute("open") && (!this.dialog || !this.dialog.open)) return
      this.removeAttribute("open")
      document.body.classList.remove("overflow-hidden")
      if (this.dialog && typeof this.dialog.close === "function" && this.dialog.open) {
        this.dialog.close()
      }
      removeTrapFocus(this.opener)
    }
  }
